// 引入axios
import axios from 'axios'
import router from '@/router'
import {GoPost} from '../../../wailsjs/go/main/App'

// axios.defaults.baseURL = 'http://localhost:8802'
// axios.defaults.baseURL = 'https://api.faniot.cn'
// 设置默认请求头
axios.defaults.headers = {
  // 'Authorization': 'Basic cm9vdDp0YW9zZGF0YQ=='
}
axios.defaults.timeout = 10000

// 设置axios拦截器: 响应拦截器
axios.interceptors.response.use(res => {
  // 成功响应的拦截
  if (res.data.code === 401) {
    router.push('/Login')
  } else {
    return Promise.resolve(res)
  }
})

export default {
  // get请求
  get (url, param, satoken) {
    return new Promise((resolve, reject) => {
      if (url === '/data/_/get/basic') {
        resolve({
          data: {
            code: 0,
            msg: 'aaa',
            data: {
              ts: Date.now()
            }
          }
        })
      } else {
        axios({
          method: 'get',
          headers: {
            satoken
          },
          url,
          params: param
        }).then(res => {
          var msg = JSON.parse(res)
          if (msg.data.code === 401) {
            if (router.history.current.path !== '/UdpErr') {
              router.push('/UdpErr')
            }
          } else {
            if (router.history.current.path === '/UdpErr') {
              router.go(-1)
            }
          }
          resolve(msg)
        }).catch(err => {
          reject(err)
        })
      }
    })
  },
  // post请求
  post (url, param, satoken) {
    return new Promise((resolve, reject) => {
      GoPost(url, JSON.stringify(param)).then(res => {
        // alert(res)
        var msg = JSON.parse(res)
        if (msg.data.code === 401) {
          if (router.history.current.path !== '/UdpErr') {
            router.push('/UdpErr')
          }
        } else {
          if (router.history.current.path === '/UdpErr') {
            router.go(-1)
          }
        }
        resolve(msg)
      })
    })
  },
  download (url, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        responseType: 'arraybuffer',
        headers: {
          satoken: window.localStorage.getItem('capacitance_token')
        },
        url,
        data: params
      }).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/request/udpRequest.js